import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./SomethingWentWrong.scss";

function SomethingWentWrong({ text = "Something went wrong." }) {
  return (
    <div className="data-state-wrapper">
      <h6 className="mb-0">
        <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning me-1" />
        {text}
      </h6>
    </div>
  );
}

export default SomethingWentWrong;
